import React from "react";

const CustomerModal = ({
  openModal,
  formData,
  setFormData,
  formErrors,
  handleMobileChange,
  handleModalClose,
  submitCustomerData,
}) => {
  if (!openModal) return null; // don’t render unless modal is open

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-auto text-sm">
        {/* Mobile No */}
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Mobile No.</label>
          <input
            type="number"
            value={formData.mobile_no}
            maxLength={10}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,10}$/.test(value)) {
                handleMobileChange(e);
              }
            }}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {formErrors.mobile_no && (
            <p className="text-red-500 text-sm mt-1">{formErrors.mobile_no}</p>
          )}
        </div>

        {/* First Name */}
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">First Name</label>
          <input
            type="text"
            value={formData.first_name}
            onChange={(e) =>
              setFormData({ ...formData, first_name: e.target.value })
            }
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {formErrors.first_name && (
            <p className="text-red-500 text-sm mt-1">{formErrors.first_name}</p>
          )}
        </div>

        {/* Last Name */}
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Last Name</label>
          <input
            type="text"
            value={formData.last_name}
            onChange={(e) =>
              setFormData({ ...formData, last_name: e.target.value })
            }
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {formErrors.last_name && (
            <p className="text-red-500 text-sm mt-1">{formErrors.last_name}</p>
          )}
        </div>

        {/* Address */}
        <div className="mb-6">
          <label className="block text-gray-700 mb-1">Address</label>
          <input
            type="text"
            value={formData.address}
            onChange={(e) =>
              setFormData({ ...formData, address: e.target.value })
            }
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {formErrors.address && (
            <p className="text-red-500 text-sm mt-1">{formErrors.address}</p>
          )}
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <button
            onClick={submitCustomerData}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Submit
          </button>

          <button
            onClick={handleModalClose}
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerModal;
